/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from "react";

type OrgRole = "Owner" | "Admin" | "Member";

interface ImpersonationContextValue {
  orgRole: OrgRole;
}

interface ImpersonationApi {
  getContext: () => ImpersonationContextValue | null;
  isImpersonating: () => boolean;
}

const defaultApi: ImpersonationApi = {
  getContext: () => null,
  isImpersonating: () => false,
};

const ImpersonationContext = createContext<ImpersonationApi>(defaultApi);

interface ImpersonationProviderProps {
  children: React.ReactNode;
  value?: Partial<ImpersonationApi>;
}

export const ImpersonationProvider: React.FC<ImpersonationProviderProps> = ({
  children,
  value,
}) => {
  const mergedValue: ImpersonationApi = {
    getContext: value?.getContext ?? defaultApi.getContext,
    isImpersonating: value?.isImpersonating ?? defaultApi.isImpersonating,
  };

  return (
    <ImpersonationContext.Provider value={mergedValue}>
      {children}
    </ImpersonationContext.Provider>
  );
};

export const useImpersonation = (): ImpersonationApi => {
  return useContext(ImpersonationContext);
};

export const ImpersonationBanner: React.FC = () => {
  return null;
};
